<div class="row" *ngIf="(invoiceLine | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Line Type</label>
            </div>
            <div class="col-sm-9">
                <select name="invoiceLineTypeID" [(ngModel)]="invoiceLine.invoiceLineTypeID" class="form-select" required>
                    <option *ngFor="let lineType of invoiceLineTypeList" value="{{lineType.invoiceLineTypeID}}">{{lineType.abbrev}} - {{lineType.description}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Quantity</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="invoiceLine.quantity" (change)="calcAmount()" min="0" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Rate</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="invoiceLine.rate" min="0" (change)="calcAmount()" step="0.01" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Extended Amount</label>
            </div>
            <div class="col-sm-9">
                <input type="number" class="form-control" [(ngModel)]="invoiceLine.invoiceAmount" min="0" [disabled]="true" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button type="button" class="btn btn-primary m-2" (click)="save()">Save</button>
            <button type="button" class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
